module.exports = __webpack_public_path__ + "media/视频文件.7fe9f324.mp4";